"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIs = require("react-is");

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var componentPropType = function componentPropType(props, propName, componentName) {
  var value = props[propName];
  if (value == null || (0, _reactIs.isValidElementType)(value)) return null;
  return new Error(componentName + ": Invalid " + propName + " value. Expected a component.");
};

var _default = (0, _createChainablePropType.default)(componentPropType, 'component');

exports.default = _default;
module.exports = exports.default;